import { Image } from '@chakra-ui/react'

export default Image
